export default __webpack_public_path__ + "eafefb3ab21bcd94dd94ea2ed2b3128e.svg";